export default "__VITE_ASSET__B$UgVahk__"